var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['zg-tile', {
    'zg-tile--product': _vm.product && !_vm.compact,
    'zg-tile--compact': _vm.product && _vm.compact,
    'zg-tile--full-width': _vm.fullWidth,
    'zg-tile--full-width-mobile': _vm.fullWidthMobile,
    'zg-tile--disabled': _vm.disabled,
    [`zg-tile--background-${_vm.background}`]: _vm.background,
  }],attrs:{"href":_vm.href,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.tag)?_c('zg-label',{staticClass:"tag",attrs:{"text":_vm.tag,"size":"small"}}):_vm._e(),_vm._v(" "),(_vm.product)?_c('span',{staticClass:"product"},[_c('zg-product-icon',{staticClass:"icon",attrs:{"product":_vm.product}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('zg-icon',{attrs:{"icon":"chevron","rotate":"270","size":"small"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }